module.exports = "img/photo10.8d7767.jpeg";